/* eslint-disable import/no-unresolved */
import {
  addDays,
  addHours,
  addMinutes,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
} from 'https://cdn.skypack.dev/date-fns@3.0.0'
/* eslint-enable import/no-unresolved */

class Countdown extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.daysHidden = false
    this.hoursHidden = false
    this.minutesHidden = false

    this.setupListeners()
  }

  setupListeners () {
    this.render = this.render.bind(this)
    this.render()

    this.timer = window.setInterval(this.render, 1000)
  }

  render () {
    const now = new Date()

    if (now > this.toDate) {
      window.clearInterval(this.timer)
      this.renderCompleted()
      return
    }

    this.renderTime(
      this.daysUntilToDate,
      this.hoursUntilToDate,
      this.minutesUntilToDate,
      this.secondsUntilToDate,
    )

    this.ariaHidden = 'false'
  }

  renderCompleted () {
    if (this.refreshPageOnEnd) {
      return window.setTimeout(() => {
        window.location.reload()
      }, 1000)
    }

    this.renderTime('00', '00', '00', '00')
    this.ariaHidden = 'false'
  }

  /**
   * @param {number} days
   * @param {number} hours
   * @param {number} minutes
   * @param {number} seconds
   */
  renderTime (days, hours, minutes, seconds) {
    if (this.days && days) {
      if (!this.daysHidden) {
        this.updateTimeElement(this.days, days, 'days')
      }
    }

    if (this.hours && hours) {
      if (!this.hoursHidden) {
        this.updateTimeElement(this.hours, hours, 'hours')
      }
    }

    if (this.minutes && minutes) {
      if (!this.minutesHidden) {
        this.updateTimeElement(this.minutes, minutes, 'minutes')
      }
    }

    if (this.seconds && seconds) {
      this.updateTimeElement(this.seconds, seconds, 'seconds')
    }
  }

  updateTimeElement (element, timeValue, timeUnit) {
    if (element) {
      const textContent = this.disablePadding
        ? timeValue.toString()
        : this.padMe(timeValue)

      let newCont = ''

      for (let index = 0; index < textContent.length; index++) {
        const element = textContent[index]

        newCont += `<span>${element}</span>`
      }
      element.innerHTML = newCont

      if (parseInt(textContent) > 1) {
        if (timeUnit === 'days') {
          if (this.daysLabelSingular !== undefined) {
            this.daysLabelSingular.ariaHidden = 'true'
          }
          if (this.daysLabelPlural !== undefined) {
            this.daysLabelPlural.ariaHidden = 'false'
          }
        } else if (timeUnit === 'hours') {
          if (this.hoursLabelSingular !== undefined) {
            this.hoursLabelSingular.ariaHidden = 'true'
          }

          if (this.hoursLabelPlural !== undefined) {
            this.hoursLabelPlural.ariaHidden = 'false'
          }
        } else if (timeUnit === 'minutes') {
          if (this.minutesLabelSingular !== undefined) {
            this.minutesLabelSingular.ariaHidden = 'true'
          }
          if (this.minutesLabelPlural !== undefined) {
            this.minutesLabelPlural.ariaHidden = 'false'
          }
        } else if (timeUnit === 'seconds') {
          if (this.secondsLabelSingular !== undefined) {
            this.secondsLabelSingular.ariaHidden = 'true'
          }
          if (this.secondsLabelPlural !== undefined) {
            this.secondsLabelPlural.ariaHidden = 'false'
          }
        }
      } else {
        if (timeUnit === 'days') {
          if (this.daysLabelSingular !== undefined) {
            this.daysLabelSingular.ariaHidden = 'false'
          }
          if (this.daysLabelPlural !== undefined) {
            this.daysLabelPlural.ariaHidden = 'true'
          }
        } else if (timeUnit === 'hours') {
          if (this.hoursLabelSingular !== undefined) {
            this.hoursLabelSingular.ariaHidden = 'false'
          }
          if (this.hoursLabelPlural !== undefined) {
            this.hoursLabelPlural.ariaHidden = 'true'
          }
        } else if (timeUnit === 'minutes') {
          if (this.minutesLabelSingular !== undefined) {
            this.minutesLabelSingular.ariaHidden = 'false'
          }
          if (this.minutesLabelPlural !== undefined) {
            this.minutesLabelPlural.ariaHidden = 'true'
          }
        } else if (timeUnit === 'seconds') {
          if (this.secondsLabelSingular !== undefined) {
            this.secondsLabelSingular.ariaHidden = 'false'
          }

          if (this.secondsLabelPlural !== undefined) {
            this.secondsLabelPlural.ariaHidden = 'true'
          }
        }
      }

      // Check if the time value is 0 and hide the corresponding column
      if (parseInt(timeValue) === 0) {
        this.toggleColumn(element, timeUnit, true)
      } else {
        this.toggleColumn(element, timeUnit, false)
      }
    }
  }

  toggleColumn (element, timeUnit, toggle) {
    const column = element.closest('.hd-CountdownBar_Column')
    if (column) {
      if (toggle) {
        column.classList.add('hd-CountdownBar_Column-hidden')
      } else {
        column.classList.remove('hd-CountdownBar_Column-hidden')
      }

      this.setHiddenFlag(timeUnit, toggle)
    }
  }

  setHiddenFlag (timeUnit, hidden) {
    if (timeUnit === 'days') {
      this.daysHidden = hidden
    } else if (timeUnit === 'hours') {
      this.hoursHidden = hidden
    } else if (timeUnit === 'minutes') {
      this.minutesHidden = hidden
    }
  }

  get days () {
    return this.els?.days?.element
  }

  get daysLabelSingular () {
    return this.els?.days_label?.element
  }

  get daysLabelPlural () {
    return this.els?.days_label_plural?.element
  }

  get hours () {
    return this.els?.hours?.element
  }

  get hoursLabelSingular () {
    return this.els?.hours_label?.element
  }

  get hoursLabelPlural () {
    return this.els?.hours_label_plural?.element
  }

  get minutes () {
    return this.els?.minutes?.element
  }

  get minutesLabelSingular () {
    return this.els?.minutes_label?.element
  }

  get minutesLabelPlural () {
    return this.els?.minutes_label_plural?.element
  }

  get seconds () {
    return this.els?.seconds?.element
  }

  get secondsLabelSingular () {
    return this.els?.seconds_label?.element
  }

  get secondsLabelPlural () {
    return this.els?.seconds_label_plural?.element
  }

  get toDate () {
    let [day, month, year] = this.date.split('/')
    day = Number(day)
    month = Number(month)
    year = Number(year)

    let [hour, minute, second] = this.time.split(':')
    hour = Number(hour)
    minute = Number(minute)
    second = Number(second) || 0

    if (this.ignoreTimezone === false) {
      hour += this.timezone
    }

    if (hour === 24) {
      hour = 0
      day += 1
    }

    return new Date(
      `${year}-${this.padMe(month)}-${this.padMe(day)}T${this.padMe(
        hour,
      )}:${this.padMe(minute)}:${this.padMe(second)}`,
    )
  }

  padMe (number) {
    return number.toString().padStart(2, '0')
  }

  get daysUntilToDate () {
    return differenceInDays(this.toDate, this.now)
  }

  get hoursUntilToDate () {
    return differenceInHours(
      this.toDate,
      addDays(this.now, this.daysUntilToDate),
    )
  }

  get minutesUntilToDate () {
    return differenceInMinutes(
      this.toDate,
      addDays(addHours(this.now, this.hoursUntilToDate), this.daysUntilToDate),
    )
  }

  get secondsUntilToDate () {
    return differenceInSeconds(
      this.toDate,
      addDays(
        addHours(
          addMinutes(this.now, this.minutesUntilToDate),
          this.hoursUntilToDate,
        ),
        this.daysUntilToDate,
      ),
    )
  }

  get date () {
    return this.dataset.date
  }

  get time () {
    return this.dataset.time
  }

  get timezone () {
    const timezoneAsANumber = Number(this.dataset.timezone)

    if (
      this.dataset.timezone.startsWith('+') ||
      this.dataset.timezone.startsWith('-')
    ) {
      return timezoneAsANumber
    }

    if (!Number.isNaN(timezoneAsANumber)) return timezoneAsANumber

    return -1
  }

  get now () {
    return Date.now()
  }

  get disablePadding () {
    return this.dataset.disablePadding === 'true'
  }

  get ignoreTimezone () {
    return this.dataset.ignoreTimezone === 'true'
  }

  get refreshPageOnEnd () {
    return this.dataset.refreshPageOnEnd === 'true'
  }
}

if (!customElements.get('countdown-bar')) {
  customElements.define('countdown-bar', Countdown)
}
